import {
  Box,
  Flex,
  ListItem,
  Span,
  UnorderedList,
  UnstyledButton,
} from '@landsbankinn/ui-kit';
import { useEffect, useRef, useState } from 'react';
import type { DebugValue } from 'src/state/server';
type DebugUsersProps = {
  inputref: React.RefObject<HTMLInputElement>;
  debugValues?: DebugValue[];
  onUserSelect: (value: DebugValue) => void;
};
export function DebugUserSelector({
  inputref,
  debugValues,
  onUserSelect,
}: DebugUsersProps) {
  const [openedDialog, setOpenedDialog] = useState<boolean>(false);
  const [showSelector, setShowSelector] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const transform = `translateY(${!openedDialog ? 'calc(-50% - 5px)' : 'calc(-50% + 5px)'})${!openedDialog ? ' rotate(180deg)' : ''}`;

  useEffect(() => {
    if (!openedDialog) return;
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(target) &&
        !inputref.current?.parentElement?.contains(target)
      ) {
        setOpenedDialog(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openedDialog, inputref]);

  useEffect(() => {
    if (inputref.current) {
      setShowSelector(true);
    } else {
      setShowSelector(false);
    }
  }, [inputref]);

  const parent = inputref.current?.parentElement;
  if (showSelector && parent && debugValues && debugValues.length > 0) {
    // Check if button already exists
    const existingBtn = parent.querySelector('[data-debug-selector-btn]');
    if (!existingBtn) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-debug-selector-btn', 'true');
      btn.innerHTML = '&#8963;'; // ▴ and ▾
      btn.style.cssText = `
      position: absolute;
      right: 12px;
      top: 50%;
      transform: ${transform};
      background: transparent;
      border: none;
      cursor: pointer;
      paddingLeft: 4px;
      font-size: 24px;
      z-index:9;
    `;
      btn.onclick = () => {
        setOpenedDialog(!openedDialog);
      };
      parent.appendChild(btn);
    } else {
      // Update existing button text and onclick
      (existingBtn as HTMLButtonElement).style.transform = transform;
      // (existingBtn as HTMLButtonElement).textContent = openedDialog ? '⌃' : '⌄';
      (existingBtn as HTMLButtonElement).onclick = () => {
        setOpenedDialog(!openedDialog);
      };
    }

    return (
      openedDialog && (
        <Box
          ref={dropdownRef}
          position="absolute"
          marginTop="92"
          padding="10"
          width={`${parent.clientWidth}`}
          overflowY="scroll"
          maxHeight="300"
          borderLeft="light"
          borderRight="light"
          borderBottom="light"
          background="blue baseLight"
          style={{ zIndex: 9999 }}
        >
          <UnorderedList color="blue font" background="blue baseLight">
            {debugValues.map((user) => {
              return (
                <ListItem
                  key={user.value}
                  color="blue font"
                  direction="row"
                  skipHeightAnimation={true}
                  onClick={() => {
                    onUserSelect(user);
                    setOpenedDialog(false);
                  }}
                >
                  <Flex
                    mainAxisAlignment="space between"
                    crossAxisAlignment="center"
                    paddingVertical="12"
                    width="100%"
                  >
                    <Span fontVariant="body">{user.displayValue}</Span>
                    <UnstyledButton
                      onClick={() => {
                        onUserSelect(user);
                        setOpenedDialog(false);
                      }}
                    >
                      {/* <AiIcon24 /> */}
                    </UnstyledButton>
                  </Flex>
                </ListItem>
              );
            })}
          </UnorderedList>
        </Box>
      )
    );
  }

  return null;
}
